'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    display: flex;\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    display: flex;\n    ', '\n    ', '\n    ', '\n    ', '\n  ']);

exports.default = function (props) {
  return (0, _styledComponents.css)(_templateObject, wrapMixin(props), directionMixin(props), justifyContentMixin(props), alignItemsMixin(props));
};

var _styledComponents = require('styled-components');

var _styledComponentsBreakpoint = require('styled-components-breakpoint');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapMixin(_ref) {
  var wrap = _ref.wrap,
      reverse = _ref.reverse,
      theme = _ref.theme;


  return (0, _styledComponentsBreakpoint.map)(wrap, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (value && reverse) {
      return 'flex-wrap: wrap-reverse;';
    } else if (value === false) {
      return 'flex-wrap: nowrap;';
    } else {
      return 'flex-wrap: wrap;';
    }
  }, theme.breakpoints);
}

function directionMixin(_ref2) {
  var reverse = _ref2.reverse,
      theme = _ref2.theme;


  //if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  if (typeof reverse === 'undefined') {
    return '';
  }

  return (0, _styledComponentsBreakpoint.map)(reverse, function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return 'flex-direction: ' + (value && 'row-reverse' || 'row') + ';';
  }, theme.breakpoints);
}

function justifyContentMixin(_ref3) {
  var halign = _ref3.halign,
      horizontalAlign = _ref3.horizontalAlign,
      reverse = _ref3.reverse,
      theme = _ref3.theme;


  //warn about deprecated usage
  if (horizontalAlign) {
    console.warn('`horizontalAlign` is deprecated. Use `valign` instead.'); //eslint-disable-line 
  }

  //if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  var alignment = halign || horizontalAlign;
  if (typeof alignment === 'undefined' && typeof reverse === 'undefined') {
    return '';
  }

  return (0, _styledComponentsBreakpoint.map)(alignment, function (value) {
    var rule = '';
    switch (value) {

      default:
      case 'left':
        if (reverse) {
          rule = 'flex-end';
        } else {
          rule = 'flex-start';
        }
        break;

      case 'right':
        if (reverse) {
          rule = 'flex-start';
        } else {
          rule = 'flex-end';
        }
        break;

      case 'center':
        rule = 'center';
        break;

      case 'justify-center':
        rule = 'space-around';
        break;

      case 'justify':
        rule = 'space-between';
        break;

    }
    return 'justify-content: ' + rule + ';';
  }, theme.breakpoints);
};

function alignItemsMixin(_ref4) {
  var valign = _ref4.valign,
      verticalAlign = _ref4.verticalAlign,
      theme = _ref4.theme;


  //warn about deprecated usage
  if (verticalAlign) {
    console.warn('`verticalAlign` is deprecated. Use `valign` instead.'); //eslint-disable-line
  }

  //if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
  var alignment = valign || verticalAlign;
  if (typeof alignment === 'undefined') {
    return '';
  }

  return (0, _styledComponentsBreakpoint.map)(valign || verticalAlign, function (value) {
    var rule = '';
    switch (value) {

      case 'top':
        rule = 'flex-start';
        break;

      case 'bottom':
        rule = 'flex-end';
        break;

      case 'center':
        rule = 'center';
        break;

      default:
      case 'stretch':
        rule = 'stretch';
        break;

    }
    return 'align-items: ' + rule + ';';
  }, theme.breakpoints);
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-grid/dist/cjs/mixins/grid.js
// module id = 482
// module chunks = 95715928098905 168707334958949